'use client';
/**
 * 匿名登录
 * 开平token获取
 * 获取用户信息
 */
import { useEffect } from 'react';

import { trackCustomEvent } from '@whelk/utils/src/track';
import useInitNative from './useInitNative';
import useInitUser from './useInitUser';
import useInitGlobalTrack from './useInitGlobalTrack';
import { LocalStorageShowLoginModal } from '@whelk/const/src/token';
import { openLoginModal } from '@whelk/utils';
import useInitConfig from './useInitConfig';
import { useTheme } from 'next-themes';
import { isNative } from '@whelk/const/src/env';
import { GetWebCommonConfigMeta } from '@whelk/services/src/type/chat';

const useInitPage = (commonConfig: GetWebCommonConfigMeta) => {
  // const isLogin = useSelector((state: RootState) => state.user.isLogin);
  // const userID = useSelector((state: RootState) => state.user.userID);
  // 必须放在useEffect中再次赋值，否则会出现水合错误
  // const isNeedTokenPath = useRef(true);
  // ---------------------------------- hook ----------------------------------
  // 登录逻辑
  useInitUser();
  // 原生初始化逻辑
  useInitNative();
  // const { initUserInfo, initMiniProgramUser, onMiniProgramOnceEvent } = useInitUser();
  // 首屏接口请求
  // 注册全局埋点
  useInitGlobalTrack();

  const { setTheme } = useTheme();
  const { onSetWebCommonConfig } = useInitConfig();

  useEffect(() => {
    if (isNative) {
      setTheme('light');
    } else {
      onSetWebCommonConfig(commonConfig);
    }
  }, []);

  // ---------------------------------- init 请求调用逻辑 ----------------------------------

  // 是否需要弹登陆弹窗
  const needOpenLoginModal = () => {
    // 如果localStorage中有showLoginModal标志，需要打开登录弹窗
    if (localStorage.getItem(LocalStorageShowLoginModal)) {
      localStorage.removeItem(LocalStorageShowLoginModal);
      openLoginModal();
    }
  };

  // 网页打开来源
  const onTrackOrigin = () => {
    // 首页来源追溯
    if (location.pathname === '/') {
      let trackOrigin = '直接打开';
      if (origin) {
        trackOrigin = origin;
      }
      trackCustomEvent({
        id: 'link_origin',
        origin: trackOrigin,
      });
    }
  };

  useEffect(() => {
    needOpenLoginModal();
    onTrackOrigin();
  }, []);
};

export { useInitPage };
